// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { decodeTextureFormat } from "./decode-texture-format.js";
import { getTextureFormatDefinition } from "./texture-format-table.js";
export function getTextureFormatCapabilities(format) {
    const info = getTextureFormatDefinition(format);
    const formatCapabilities = {
        format,
        create: info.f ?? true,
        render: info.render ?? true,
        filter: info.filter ?? true,
        blend: info.blend ?? true,
        store: info.store ?? true
    };
    const formatInfo = decodeTextureFormat(format);
    const isDepthStencil = format.startsWith('depth') || format.startsWith('stencil');
    const isSigned = formatInfo?.signed;
    const isInteger = formatInfo?.integer;
    const isWebGLSpecific = formatInfo?.webgl;
    // signed formats are not renderable
    formatCapabilities.render &&= !isSigned;
    // signed and integer formats are not filterable
    formatCapabilities.filter &&= !isDepthStencil && !isSigned && !isInteger && !isWebGLSpecific;
    return formatCapabilities;
}
//# sourceMappingURL=texture-format-capabilities.js.map